import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { interval } from 'rxjs';
import { tap, throttle } from 'rxjs/operators';
import { UserManagementService } from 'src/app/services/user-management.service';
import { RequestUtil } from 'src/app/utils/request.util';
import { SiteSearch } from '../../interfaces/site-search.interface';
import { AnalyticsUtil } from '../../utils/analytics.util';
import { ActionTypes, SiteSearchNavigate, SiteSearchQuery } from '../actions/search.action';

@Injectable()
export class AnalyticsEffects {
    onSiteSearchQuery$ = createEffect(() => this.action$
        .pipe(
            ofType<SiteSearchQuery>(ActionTypes.SiteSearchQuery),
            throttle(() => interval(1)),
            tap(action => {
                const payload: SiteSearch = action.payload;
                void this.analyticsUtil.trackSiteSearch(payload.query, payload.productId, payload.results);
            })
        ), {dispatch: false});

    onSiteSearchNavigate$ = createEffect(() => 
        this.action$
            .pipe(
                ofType<SiteSearchNavigate>(ActionTypes.SiteSearchNavigate),
                throttle(() => interval(1)),
                tap(action => {
                    const payload = action.payload;            
                    void this.analyticsUtil.trackSiteSearchNavigate(
                        payload.category,
                        payload.search.query,
                        payload.search.productId,
                        payload.search.results,
                    );
                })
            )
    , {dispatch: false});

    constructor(
        private action$: Actions,
        private analyticsUtil: AnalyticsUtil,
        private userManagementService: UserManagementService,
        private requestUtil: RequestUtil
    ) {}


}
